import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "width": 800,
      "data-sign": "shop_mapping_log_modal",
      "title": _vm.t('日志')
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    staticClass: "box min-ptext",
    attrs: {
      "bordered": "",
      "data-sign": "shop_mapping_log_list",
      "name": "shopMappingLogList",
      "fixed-header": "",
      "columns": _vm.columns,
      "data-source": _vm.data,
      "row-key": "id",
      "pagination": false
    }
  })], 1), _c('div', {
    staticClass: "pagination-box"
  }, [_c('my-pagination', {
    attrs: {
      "current": _vm.searchData.page_index,
      "name": "shopMappingLogList",
      "total": _vm.total,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  })], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "fbu-analyse-name": $t("\u5173\u95ED")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('关闭')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };